import { h as V, ref as L, onMounted as B, onUnmounted as E, unref as y, defineComponent as T, computed as C, watch as F, openBlock as d, createElementBlock as k, Fragment as H, createElementVNode as o, normalizeClass as s, createCommentVNode as v, withModifiers as f, renderSlot as P, createBlock as A, createVNode as z, renderList as D } from "vue";
import { d as O } from "./ArrowIcon.GDkXwpPs.js";
import { o as q } from "./DownloadIcon.DHCHRETy.js";
const N = (r, { attrs: u }) => {
  r = { ...q(), ...r };
  const { width: a, height: i } = r;
  return V(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 11.175 13.409",
      width: `${a}`,
      height: `${i}`,
      class: r.class ?? "",
      "aria-hidden": u["aria-hidden"] ?? "true",
      fill: "none",
      stroke: u["stroke-color"] ?? "#FA4F64"
    },
    [
      V("circle", {
        cx: 6,
        cy: 6,
        r: 4.5
      }),
      V("path", {
        "stroke-linejoin": "round",
        d: "M5.8 3.6h.4L6 6.5z"
      }),
      V("circle", {
        cx: 6,
        cy: 8.2,
        r: 0.6,
        fill: u["stroke-color"] ?? "#FA4F64",
        stroke: "none"
      })
    ]
  );
}, S = (r) => {
  const { isDropdownOpen: u, disableSpaceHandler: a } = r, i = L(-1), h = L(-1), b = (t) => {
    const p = "ArrowUp", g = "ArrowDown", m = "Enter", w = "Escape", e = " ", l = "PageUp", n = "Home", c = "PageDown", $ = "End";
    if (!u.value || ![
      p,
      g,
      m,
      w,
      e,
      l,
      n,
      c,
      $
    ].includes(t.key))
      return;
    const M = y(r.optionsLength);
    if (t.key === p)
      i.value = i.value === 0 ? M - 1 : i.value - 1;
    else if (t.key === g)
      i.value = (i.value + 1) % M;
    else if (t.key === m || t.key === e) {
      if (t.key === e && a)
        return;
      h.value = i.value, u.value = !1;
    } else
      t.key === w ? (i.value = h.value, u.value = !1) : t.key === l || t.key === n ? i.value = 0 : (t.key === c || t.key === $) && (i.value = M - 1);
    t.stopPropagation(), t.preventDefault();
  };
  return B(() => {
    document && document.addEventListener("keydown", b);
  }), E(() => {
    document && document.removeEventListener("keydown", b);
  }), {
    activeIdx: i,
    selectedIdx: h
  };
}, U = ["id", "innerHTML"], j = ["id", "data-cy", "aria-required", "aria-controls", "aria-labelledby", "aria-expanded", "aria-activedescendant", "aria-invalid", "aria-describedby"], I = ["innerHTML"], Y = { class: "uikit-mt-1 uikit-inline-flex uikit-pointer-events-none" }, G = ["innerHTML"], J = ["data-cy"], K = ["id", "aria-selected", "onClick", "onMouseover"], Q = { class: "uikit-inline-block uikit-cursor-pointer uikit-text-sm" }, R = ["name", "checked", "onInput"], W = ["innerHTML"], X = ["id", "arial-live", "innerHTML"], Z = ["id", "arial-live", "innerHTML"], ie = /* @__PURE__ */ T({
  inheritAttrs: !1,
  __name: "AccessibleSelect",
  props: {
    label: { default: "" },
    dropdownPosition: { default: "bottom" },
    namespace: {},
    options: {},
    modelValue: { default: () => ({
      id: "",
      label: ""
    }) },
    isValid: { type: [Boolean, null], default: null },
    feedback: {},
    closeOnBodyPressed: { type: Boolean, default: !0 },
    border: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue"],
  setup(r, { emit: u }) {
    const a = r, i = L(!1), h = L(null), b = C(() => !!a.modelValue.label), t = u, { activeIdx: p, selectedIdx: g } = S({
      optionsLength: a.options.length,
      isDropdownOpen: i
    }), m = (e) => {
      i.value = !1, t("update:modelValue", e);
    };
    F(g, (e) => {
      m(a.options[e]), i.value = !1;
    });
    const w = ({ target: e }) => {
      `${a.namespace}_btn` !== e.id && (i.value = !1);
    };
    return B(() => {
      a.closeOnBodyPressed && document && document.addEventListener("click", w);
    }), E(() => {
      a.closeOnBodyPressed && document && document.removeEventListener("click", w);
    }), (e, l) => (d(), k(H, null, [
      o("div", {
        class: s(["uikit-relative uikit-flex uikit-h-12 uikit-items-center", [e.$attrs.class]])
      }, [
        e.label ? (d(), k("label", {
          key: 0,
          id: `${e.namespace}_label`,
          class: s(["uikit-absolute uikit-text-sm uikit-font-medium uikit-transition-all uikit-ease-in-out uikit-pointer-events-none uikit-z-10", [
            b.value ? "as-floating -uikit-top-1 uikit-left-[22px] uikit-text-w-black" : "as-inline uikit-top-4 uikit-text-w-gray",
            e.$attrs["label-classes"],
            { "uikit-left-9": e.$slots.lefticon && !b.value },
            { "uikit-left-4": !e.$slots.lefticon && !b.value }
          ]]),
          innerHTML: e.label
        }, null, 10, U)) : v("", !0),
        e.$slots.lefticon ? (d(), k("span", {
          key: 1,
          class: "uikit-z-20 uikit-pl-2 uikit-mt-2",
          onClick: l[0] || (l[0] = f((n) => i.value = !i.value, ["stop"]))
        }, [
          P(e.$slots, "lefticon")
        ])) : v("", !0),
        o("button", {
          id: `${e.namespace}_btn`,
          ref_key: "btnEl",
          ref: h,
          type: "button",
          "data-cy": e.$attrs["data-cy"],
          class: s(["uikit-peer uikit-flex uikit-h-full uikit-w-full uikit-items-center uikit-justify-between uikit-truncate uikit-border-0 uikit-pr-4 uikit-text-left focus-visible:uikit-outline-0 uikit-bg-transparent uikit-relative uikit-z-10", [e.$slots.lefticon ? "uikit-pl-2" : "uikit-pl-4", e.$attrs["btn-classes"]]]),
          "aria-required": !!e.$attrs.required,
          role: "combobox",
          "aria-haspopup": "listbox",
          "aria-controls": `${e.namespace}_dropdown`,
          "aria-labelledby": `${e.namespace}_label ${e.namespace}_btn`,
          "aria-expanded": i.value,
          "aria-activedescendant": y(p) >= 0 && i.value ? `${e.namespace}_element_${e.options[y(p)].label}` : "",
          "aria-invalid": a.isValid === !1,
          "aria-describedby": a.isValid === !1 ? `${e.namespace}_invalid_msg` : void 0,
          onClick: l[1] || (l[1] = (n) => i.value = !i.value)
        }, [
          o("span", {
            class: s(["uikit-mt-1 uikit-pointer-events-none", e.$attrs["btn-text-classes"]]),
            innerHTML: e.modelValue.visibleLabel || e.modelValue.label
          }, null, 10, I),
          o("span", Y, [
            a.isValid == !1 ? (d(), A(y(N), {
              key: 0,
              class: "uikit-mr-1",
              width: 20,
              height: 20
            })) : v("", !0),
            z(y(O), {
              class: s(["uikit-transition-transform motion-reduce:uikit-transition-none", i.value ? "uikit-rotate-180" : ""]),
              width: 18,
              height: 18,
              "stroke-color": e.isValid ? "#2B5DFF" : e.isValid === !1 ? "#FA4F64" : "#222"
            }, null, 8, ["class", "stroke-color"])
          ])
        ], 10, j),
        o("fieldset", {
          "aria-hidden": "true",
          class: s(["uikit-pointer-events-none uikit-absolute uikit-bottom-0 uikit-left-0 uikit-right-0 uikit-m-0 uikit-box-border uikit-h-12 uikit-cursor-pointer uikit-rounded-xs uikit-px-2 uikit-py-0 peer-focus:uikit-border-2 uikit-bg-white", [
            e.$attrs["fieldset-classes"],
            e.isValid ? "uikit-border-w-primary" : e.isValid === !1 ? "uikit-border-w-danger" : "uikit-border-w-secondary",
            { "uikit-border uikit-border-solid peer-focus:uikit-border-w-primary peer-focus-visible:uikit-border-2 peer-focus-visible:uikit-border-w-primary peer-aria-invalid:uikit-border-w-danger": e.border },
            { "uikit-border-0 peer-focus:uikit-border-0": !e.border }
          ]])
        }, [
          o("legend", {
            class: s([e.$attrs["legend-classes"], { "uikit-m-0 uikit-w-0": !e.label }, "uikit-ml-2 uikit-h-3 uikit-px-0 uikit-text-sm"])
          }, [
            o("span", {
              class: s(["uikit-mx-5px", [e.modelValue.label ? "uikit-invisible" : "uikit-hidden"]]),
              innerHTML: e.label
            }, null, 10, G)
          ], 2)
        ], 2),
        o("ul", {
          "data-cy": e.$attrs["data-cy"] && `${e.$attrs["data-cy"]}_dropdown`,
          role: "listbox",
          tabindex: -1,
          "aria-multiselectable": !1,
          class: s(["uikit-absolute uikit-z-30 uikit-m-0 uikit-max-h-[225px] uikit-w-full uikit-min-w-full uikit-list-none uikit-overflow-y-auto uikit-p-0 uikit-no-scrollbar", [
            { "uikit-h-0 uikit-w-0 uikit-overflow-hidden": !i.value },
            {
              "uikit-rounded-xs uikit-border uikit-border-solid uikit-border-w-secondary uikit-bg-white": i.value
            },
            { "uikit-bottom-[55px]": e.dropdownPosition === "top" },
            { "uikit-top-[55px]": e.dropdownPosition === "bottom" },
            e.$attrs["dropdown-classes"]
          ]]),
          onClick: l[3] || (l[3] = f(() => {
          }, ["stop"]))
        }, [
          (d(!0), k(H, null, D(e.options, (n, c) => (d(), k("li", {
            id: `${e.namespace}_element_${e.options[c].label}`,
            key: `${n.label}_${c}`,
            role: "option",
            "aria-selected": y(p) === c,
            class: s(["uikit-m-1 uikit-cursor-pointer uikit-px-20px uikit-py-10px uikit-text aria-selected:uikit-rounded-xs aria-selected:uikit-bg-w-cultured", e.$attrs["dropdown-item-classes"]]),
            onClick: f(($) => m(n), ["stop"]),
            onMouseover: f(($) => p.value = c, ["stop"]),
            onBlur: l[2] || (l[2] = f(() => {
            }, ["stop"]))
          }, [
            o("label", Q, [
              o("input", {
                tabindex: "-1",
                class: "uikit-m-0 uikit-appearance-none",
                name: `${e.namespace}_radio`,
                type: "radio",
                checked: n.label === e.modelValue.label,
                onInput: f(($) => m(n), ["stop"])
              }, null, 40, R),
              o("span", {
                innerHTML: n.label
              }, null, 8, W)
            ])
          ], 42, K))), 128))
        ], 10, J)
      ], 2),
      e.feedback ? (d(), k(H, { key: 0 }, [
        e.feedback.valid ? (d(), k("span", {
          key: 0,
          id: `${e.namespace}_valid_msg`,
          "arial-live": e.$attrs["aria-live"],
          class: "uikit-mb-2 uikit-text-sm",
          innerHTML: e.isValid ? e.feedback.valid : ""
        }, null, 8, X)) : v("", !0),
        e.feedback.invalid ? (d(), k("span", {
          key: 1,
          id: `${e.namespace}_invalid_msg`,
          "arial-live": e.$attrs["aria-live"],
          class: "uikit-mb-2 uikit-text-sm uikit-text-w-danger",
          innerHTML: e.isValid === !1 ? e.feedback.invalid : ""
        }, null, 8, Z)) : v("", !0)
      ], 64)) : v("", !0)
    ], 64));
  }
});
export {
  ie as _
};
